const CONSENT_KEY = 'netgrav_cookies';
const LEGACY_VISIT_KEY = 'ng.last_visit';

const removeGoogleCookies = () => {
  if (typeof document === 'undefined') return;
  const hostname = window.location.hostname;
  const hostnameParts = hostname.split('.');
  const baseDomain = hostnameParts.length > 1 ? hostnameParts.slice(-2).join('.') : hostname;

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0]?.trim();
    if (
      !name ||
      (!name.startsWith('_ga') && !name.startsWith('_gcl') && name !== '_gid' && name !== '_gat')
    ) {
      return;
    }
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    [hostname, baseDomain].forEach((domain) => {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain}; SameSite=Lax`;
    });
  });
};

export function clearLegacyGoogleAnalytics() {
  try {
    localStorage.removeItem(CONSENT_KEY);
    localStorage.removeItem(LEGACY_VISIT_KEY);
  } catch {}
  removeGoogleCookies();
}

// Existing call sites remain harmless until product events have a first-party home.
export function trackEvent() {}
